import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})

export class HeartlandObserverService {
  private heartlandToken = new BehaviorSubject<any>({});
  cast = this.heartlandToken.asObservable();

  private heartlandAmountToken = new BehaviorSubject<number>(0);
  castamount = this.heartlandAmountToken.asObservable();

  private customerCountryToken = new BehaviorSubject<any>({});
  castcountry = this.customerCountryToken.asObservable();

  private paymentFormInfo = new BehaviorSubject<any>({});
  castPaymentFormInfo = this.paymentFormInfo.asObservable();

  constructor() { }

  updateTokenData(tokenData){
    this.heartlandToken.next(tokenData);
  }

  updateAmountData(tokenData){
    this.heartlandAmountToken.next(tokenData);
  }

  updateCustomerCountry(tokenData){
    this.customerCountryToken.next(tokenData);
  }

  updatePaymentFormInfo(paymentFormInfo){
    this.paymentFormInfo.next(paymentFormInfo);
  }
}
